import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const StatisticsCardSkeleton = ({ style }) => {
  return (
    <Card className="overflow-hidden" style={style}>
      <Card.Body className="position-relative">
        <h5>
          <Skeleton />
        </h5>
        <div className="display-4 fs-4 mb-2 font-sans-serif card-fw-2">
          <Skeleton />
        </div>
        <h6 className="mb-0 mt-2 score-card-text">
          <Skeleton />
        </h6>
      </Card.Body>
    </Card>
  );
};

StatisticsCardSkeleton.propTypes = {
  style: PropTypes.object
};

const StatiticsCardsSkeleton = () => {
  return (
    <Row className="g-3 mb-0">
      {[...Array(4).keys()].map(index => (
        <Col key={index} sm={6} md={6}>
          <StatisticsCardSkeleton
            style={{ minWidth: '12rem', height: '100%' }}
          />
        </Col>
      ))}
    </Row>
  );
};

export default StatiticsCardsSkeleton;
